import CONSTANTS, { FUORI_SEDE } from "../../../shared/utils/Constants";
import { Setting } from "../../../shared/utils/Settings";
import { DELAY } from "../../../shared/utils/Utils";
import SegnalazioneChoiceLists from "../../mocks/SegnalazioneChoiceLists";
import { SegnalazioneChoiceList } from "../../models/objs/SegnalazioneChoiceList";
import { CurrencyTypes } from "../../models/output-objs/currencyOutput";
import { ForeignAuthorities } from "../../models/output-objs/foreignAuthoritiesOutput";
import { LegalForms } from "../../models/output-objs/LegalFormsOutput";
import { Nation } from "../../models/output-objs/NationsOutput";
import { NegotiatedActivityKind } from "../../models/output-objs/NegotiatedActivityKindsOutput";
import { NegotiatedInstrumentKinds } from "../../models/output-objs/NegotiatedInstrumentKindsOutput";
import { Province } from "../../models/output-objs/ProvinceOutput";
import { Region } from "../../models/output-objs/RegionOutput";
import { ReportingSubjectRoles } from "../../models/output-objs/ReportingSubjectRolesOutput";
import { ReportingSubjectTypes } from "../../models/output-objs/ReportingSubjectTypesOutput";
import { SuspicionType } from "../../models/output-objs/SuspicionTypeOutput";
import { Timezone } from "../../models/output-objs/TimezoneOutput";
import { CatalogService } from "./CatalogsService";


export async function GetCatalogList(userType? : string): Promise<SegnalazioneChoiceList>{
    let segnalazioneChoiceList : SegnalazioneChoiceList= {}
    if(userType && userType.toLowerCase().includes(CONSTANTS.internalUserRole)){
        segnalazioneChoiceList = {
            tipoSoggettoSegnalante: await getReportingSubjectTypesStructure(),
            formaGiuridica: await getLegalFormsStructure(),
            regione: await getRegionStructure(),
            provincia: await getProvincesStructure(),
            nazione: await getNationsStructure(),
            vesteSegnalante: await getVesteSegnalanteStructure(),
            catTipologiaNegoziazione: await getNegotiatedActivityKindsStructure(),
            catTipologiaStrumNegoziato: await getNegotiatedInstrumentKindsStructure(),
            currency : await getCurrencyStructure(),
            fuoriSede: FUORI_SEDE,
            fusoOrario: await getTimezoneStructure(),
            naturaSospetto: await getSuspicionTypeStructure(),
            foreignAuth: await getForeignAuthorities(),
            internalSuspect: await getSuspectInternal(),
            macroCategories: await getMacroCategories(),
            funzionari: await getFunzionari(),
            assignType: await getAssignTypeList()
        };
    }
    else{
        segnalazioneChoiceList = {
            tipoSoggettoSegnalante: await getReportingSubjectTypesStructure(),
            formaGiuridica: await getLegalFormsStructure(),
            regione: await getRegionStructure(),
            provincia: await getProvincesStructure(),
            nazione: await getNationsStructure(),
            vesteSegnalante: await getVesteSegnalanteStructure(),
            catTipologiaNegoziazione: await getNegotiatedActivityKindsStructure(),
            catTipologiaStrumNegoziato: await getNegotiatedInstrumentKindsStructure(),
            currency : await getCurrencyStructure(),
            fuoriSede: FUORI_SEDE,
            fusoOrario: await getTimezoneStructure(),
            naturaSospetto: await getSuspicionTypeStructure()
        };
    }
    return segnalazioneChoiceList;
}

async function getCurrencyStructure(): Promise<CurrencyTypes[]>{
    let catalogService = new CatalogService();
    let currency = await catalogService.getCurrency();
    if(currency && currency.totalElements > 0 && currency.elements){
        return currency.elements;
    }
    else{
        return [];
    }
}

async function getRegionStructure(): Promise<Region[]>{
    let catalogService = new CatalogService();
    let regions = await catalogService.getRegions();
    if(regions && regions.totalElements > 0 && regions.elements){
        return regions.elements;
    }
    else{
        return [];
    }
}

async function getTimezoneStructure(): Promise<Timezone[]>{
    let catalogService = new CatalogService();
    let timezone = await catalogService.getTimezone();
    if(timezone && timezone.totalElements > 0 && timezone.elements){
        return timezone.elements;
    }
    else{
        return [];
    }
}

async function getProvincesStructure(): Promise<Province[]>{
    let catalogService = new CatalogService();
    let provinces = await catalogService.getProvinces();
    if(provinces && provinces.totalElements > 0 && provinces.elements){
        return provinces.elements;
    }
    else{
        return [];
    }
}

async function getLegalFormsStructure(): Promise<LegalForms[]>{
    let catalogService = new CatalogService();
    let legalForms = await catalogService.getLegalForms();
    if(legalForms && legalForms.totalElements > 0 && legalForms.elements){
        return legalForms.elements;
    }
    else{
        return [];
    }
}

async function getNationsStructure(): Promise<Nation[]>{
    let catalogService = new CatalogService();
    let nations = await catalogService.getNations();
    if(nations && nations.totalElements > 0 && nations.elements){
        return nations.elements;
    }
    else{
        return [];
    }
}

async function getSuspicionTypeStructure(): Promise<SuspicionType[]>{
    let catalogService = new CatalogService();
    let suspicionType = await catalogService.getSuspicionType();
    if(suspicionType && suspicionType.totalElements > 0 && suspicionType.elements){
        return suspicionType.elements;
    }
    else{
        return [];
    }
}

async function getReportingSubjectTypesStructure(): Promise<ReportingSubjectTypes[]>{
    let catalogService = new CatalogService();
    let reportingSubjectTypes = await catalogService.getReportingSubjectTypes();
    if(reportingSubjectTypes && reportingSubjectTypes.totalElements > 0 && reportingSubjectTypes.elements){
        return reportingSubjectTypes.elements;
    }
    else{
        return [];
    }
}

async function getNegotiatedActivityKindsStructure(): Promise<NegotiatedActivityKind[]>{
    let catalogService = new CatalogService();
    let negotiatedActivityKinds = await catalogService.getNegotiatedActivityKinds();
    if(negotiatedActivityKinds && negotiatedActivityKinds.totalElements > 0 && negotiatedActivityKinds.elements){
        return negotiatedActivityKinds.elements;
    }
    else{
        return [];
    }
}

async function getNegotiatedInstrumentKindsStructure(): Promise<NegotiatedInstrumentKinds[]>{
    let catalogService = new CatalogService();
    let negotiatedInstrumentKinds = await catalogService.getNegotiatedInstrumentKinds();
    if(negotiatedInstrumentKinds && negotiatedInstrumentKinds.totalElements > 0 && negotiatedInstrumentKinds.elements){
        return negotiatedInstrumentKinds.elements;
    }
    else{
        return [];
    }
}

async function getVesteSegnalanteStructure(): Promise<ReportingSubjectRoles[]>{
    let catalogService = new CatalogService();
    let vesteSegnalante = await catalogService.getReportingSubjectRoles();
    if(vesteSegnalante && vesteSegnalante.totalElements > 0 && vesteSegnalante.elements){
        return vesteSegnalante.elements;
    }
    else{
        return [];
    }
}

export async function getForeignAuthorities(): Promise<ForeignAuthorities[]>{
    let catalogService = new CatalogService();
    let foreignAuthorities = await catalogService.getForeignAuthorities();
    if(foreignAuthorities && foreignAuthorities.totalElements > 0 && foreignAuthorities.elements){
        return foreignAuthorities.elements;
    }
    else{
        return [];
    }
}

export async function getSuspectInternal(): Promise<any[]>{
    let catalogService = new CatalogService();
    let categories = await catalogService.getInternalSuspect();
    if(categories && categories.totalElements > 0 && categories.elements){
        return categories.elements;
    }
    else{
        return [];
    }
}

export async function getMacroCategories(): Promise<any[]>{
    let catalogService = new CatalogService();
    let internalSuspect = await catalogService.getMacroCategories();
    if(internalSuspect && internalSuspect.totalElements > 0 && internalSuspect.elements){
        return internalSuspect.elements;
    }
    else{
        return [];
    }
}

export async function getFunzionari(): Promise<any[]>{
    let catalogService = new CatalogService();
    let funzionari = await catalogService.getFunzionari();
    if(funzionari && funzionari.totalElements > 0 && funzionari.elements){
        return funzionari.elements;
    }
    else{
        return [];
    }
}

export async function getAssignTypeList(): Promise<any[]>{
    let catalogService = new CatalogService();
    let type = await catalogService.getAssignType();
    if(type && type.totalElements > 0 && type.elements){
        return type.elements.filter((e:any)=>e.name !=='Esonerato');
    }
    else{
        return [];
    }
}
